import { useState } from "react";
import { jeopardyApi } from "../api/jeopardy";

export const useMarkAsRead = ({ refetch }: { refetch: () => void }) => {

    const [isOpen, setIsOpen] = useState(false);

    const [completeNotes, setCompleteNotes] = useState("");
    const [error, setError] = useState(null as string | null);

    const handleOpen = () => setIsOpen(true);
    const handleClose = () => setIsOpen(false);

    const handleSubmitMarkAsRead = async (jeopardyId: string) => {
        if (!completeNotes) {
            setError("Completion notes is required");
            return;
        }
        const payload = {
            "completion_text": completeNotes,
            "action": "CLOSE"
        };
        await jeopardyApi.updateMarkAsClosed({ jeopardyId: jeopardyId, paylod: payload });
        handleClose();
        refetch();
    };

    return {
        isOpen,
        handleOpen,
        handleClose,
        completeNotes,
        setCompleteNotes,
        error,
        handleSubmitMarkAsRead
    };

};